import React from 'react';
import {
    BooleanInput,
    Create,
    FormTab,
    TabbedForm,
    TextField,
    TextInput,
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

const user = `/users/${window.localStorage.getItem('ltk-comments-admin-id')}`;

export const ThreadCreate = (props) => (
    <Create {...props}>
        <TabbedForm
            defaultValue={{ user }}
        >
            <FormTab label="Main">
                <TextField source="user" />
                <BooleanInput label="Closed?" source="closed" />
                <TextInput label="Link" source="link" />
                <TextInput label="Title" source="title" />
            </FormTab>
            <FormTab label="Message">
                <RichTextInput source="message" />
            </FormTab>
        </TabbedForm>
    </Create>
)
